import { useState, useEffect } from 'react';
import axios from 'axios';

const path = '/api/insuredMine/v1/getInsuredMineEnabled';

export function useGetInsuredMineEnabled(getInsuredMineEnableState) {
  const [insuredMineEnabled, setInsuredMineEnabled] = useState({
    fetching: false,
    error: false,
    success: false,
    data: undefined,
  });
  useEffect(() => {
    const getInsuredMineEnabled = async () => {
      setInsuredMineEnabled({ fetching: true, error: false, success: false });
      try {
        const response = await axios.get(path);
        if (response.status !== 200) {
          setInsuredMineEnabled({
            fetching: false,
            success: false,
            error: true,
            data: undefined,
          });
        } else {
          setInsuredMineEnabled({
            fetching: false,
            success: true,
            error: false,
            data: response.data.data,
          });
        }
      } catch (e) {
        setInsuredMineEnabled({ fetching: false, error: true, success: false });
      }
    };
    if (getInsuredMineEnableState === true) {
      getInsuredMineEnabled();
    }
  }, [getInsuredMineEnableState]);
  return insuredMineEnabled;
}
